import { pageTitle } from 'ember-page-title';
import { LoginWrapper } from 'password-form';

<template>
  {{pageTitle "Lighthouse" separator=" - "}}

  <LoginWrapper>
    {{outlet}}
  </LoginWrapper>
  <div id="ember-basic-dropdown-wormhole"></div>
</template>
